"use strict";
import { ColorHandle } from "./src/ColorHandle.dev.js";
import { defineElement } from "@spectrum-web-components/base/src/define-element.js";
defineElement("sp-color-handle", ColorHandle);
//# sourceMappingURL=sp-color-handle.dev.js.map
